import { icons } from '@src/plugins/ckeditor5-core/src/index';
import { ButtonView, View } from '@src/plugins/ckeditor5-ui/src/index';

class KityFormularView extends View {
	constructor( locale, formularHtmlUrl ) {
		super( locale );
		const bind = this.bindTemplate;
		this.set( 'visibleClass', 'ck-fdialog-hidden' );
		this.set( 'styles', 'width:782px;height:482px' );

		const closeBtn = new ButtonView();
		closeBtn.set( {
			icon: icons.cancel,
			tooltip: false
		} );
		closeBtn.on( 'execute', () => this.fire( 'close' ) );

		this.setTemplate( {
			tag: 'div',
			children: [
				{
					tag: 'div',
					attributes: {
						class: 'ck-fdialog',
						style: bind.to( 'styles' )
					},
					children: [
						{
							tag: 'div',
							children: [
								'插入公式',
								closeBtn
							],
							attributes: {
								class: [ 'ck-dialog-title' ]
							}
						},
						{
							tag: 'iframe',
							attributes: {
								width: '780px',
								height: '380px',
								border: 'none',
								frameborder: '0',
								scrolling: 'no',
								src: formularHtmlUrl
							}
						},
						{
							tag: 'div',
							attributes: {
								class: 'ck-dialog-bottom'
							},
							children: [
								{
									tag: 'div',
									children: [
										'居中插入'
									],
									attributes: {
										class: 'ck-dialog-button'
									},
									on: {
										click: bind.to( 'insertAsImage' )
									}
								},
								{
									tag: 'div',
									children: [
										'行内插入'
									],
									on: {
										click: bind.to( 'insertInline' )
									},
									attributes: {
										class: 'ck-dialog-button'
									}
								}
							]
						}

					]
				}
			],
			attributes: {
				class: [ 'ck-fdialog-overlay',
					bind.to( 'visibleClass' )
				]
			}
		} );
	}
}
export default KityFormularView;
